
const state = {};

export default class ReferencePage {
    static init() {
        if (!window?.neos?.guestFrame?.findElementByNode) {
            return;
        }

        document.addEventListener('Neos.NodeCommit', (event) => {
            const {node, property} = event.detail;

            if (node.nodeType !== 'CodeQ.Site:Document.ReferencePage') {
                return;
            }

            this.updatePin(node, property)
        })

        document.addEventListener('Neos.NodeDiscard', (event) => {
            const {node, properties} = event.detail;

            if (node.nodeType !== 'CodeQ.Site:Document.ReferencePage') {
                return;
            }

            properties.forEach(property => {
                this.updatePin(node, property)
            })
        })
    }

    static updatePin(node, property) {
        state[node.identifier] = state[node.identifier] || {
            horizontalPosition: node.properties.horizontalPosition/10,
            verticalPosition: node.properties.verticalPosition/10,
        };
        const {name, updated} = property;
        switch(name) {
            case 'horizontalPosition': state[node.identifier].horizontalPosition = updated/10; break;
            case 'verticalPosition': state[node.identifier].verticalPosition = updated/10; break;
            default: return;
        }
        const {horizontalPosition, verticalPosition} = state[node.identifier];

        // keep this in sync with InteractiveMapWithAccordion.MapPin.fusion
        const svgViewboxSize = {
            width: 1076,
            height: 605,
        };
        const pinSize = {
            width: 27.5,
            height: 36,
        };
        const pinPosition = {
            top: verticalPosition * svgViewboxSize.height / 100 + (pinSize.height / 2),
            left: horizontalPosition * svgViewboxSize.width / 100 + (pinSize.width / 2),
        };
        const pinId = 'reference-page-pin-' + node.identifier;
        const pin = document.querySelector(`[data-corresponding-accordion-item-id="${pinId}"]`);
        if (!pin) return;

        const transform = `translate(${pinPosition.left},${pinPosition.top})`;
        pin.setAttribute('transform', transform);
        pin.setAttribute('data-transform', transform);
    }
}
